import React, {useEffect, useState }  from 'react';
import { Link } from 'react-router-dom';
import { connect } from 'react-redux';
import { getItem } from '@craftercms/content';
import { languagePicker, getLabel} from '../../utils';

import FooterHolder from './FooterStyles';

const Footer = (props) => {
  
  const [links, setLinks] = useState([]);
  const [linksImages, setLinksImages] = useState([]);

  useEffect(()=> {
      getItem("/site/components/common/footer.xml").subscribe((item) => {
        if (item) {
          let fieldNames = ["links_o.name_s","links_o.url_s", "image_links_o.alt_image_s", "image_links_o.url_s"]
          languagePicker(item, fieldNames);
          setLinks(item.descriptorDom.component.links_o.item);	
          setLinksImages(item.descriptorDom.component.image_links_o.item);
        }
      });
    },[props.current_lang]);

    const setCopyCurrentDate = ()=> {
      const today = new Date();
      const currentYear = today.getFullYear();
      const regex = /\s(\d{4}-\d{4}|\d{4})/g;
      let copy = getLabel("FOOTERCOPY");
      if(copy !== undefined) {
        let math = copy.match(regex);
        copy = copy.replace(math[math.length-1], " " + currentYear);
  
        return copy;
      }
    }

    const renderSponsors = () => {
      return linksImages.map((item,i)=>{
        return <a key={i} href={item.url} target="_blank" rel="noreferrer"><img src={item.image} alt={item.alt_image}/><meta itemProp='sponsor' content={item.alt_image} /></a>
      });
    }

    const renderLinks = () => {
      return links.map((link,i)=>{
        return <Link key={`footer-link-${i}`}to={link.url}>{link.name}</Link>
      });
    }
    
    return (
      <FooterHolder> 
        <div className="footer" id="footer" tabIndex="0" aria-label="footer of the page" itemScope itemType='https://schema.org/WPFooter'> 
          <div className="footer__links">
            <div className="footer__links__container">{renderLinks()} </div>
            <p tabIndex="0" className="footer__links__copyright" itemProp='copyrightNotice'>{setCopyCurrentDate()}</p>
          </div>
          <div className="footer__sponsors">
            <p className="footer__sponsors__title">{getLabel("FOOTERTITLE")}</p>
            <div className="footer__sponsors__images-cont">{renderSponsors()} </div>
          </div>
          <p tabIndex="0" className="footer__links__copyright is-mobile" itemProp='copyrightNotice'>{setCopyCurrentDate()}</p>
        </div>
      </FooterHolder>
    )
}

const mapStateToProps = (store) => ({
  current_lang: store.language.current,
});

export default connect(mapStateToProps,null)(Footer);